module.exports = __webpack_public_path__ + "img/bluesky3100_01.b92bb3f3.jpg";